
interface HeaderProps {
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
}

const Header = ({ activeTab = 'inicio', setActiveTab }: HeaderProps) => {
  const menuItems = [
    { id: 'inicio', label: 'Inicio', icon: 'ri-home-line' },
    { id: 'calendario', label: 'Calendario', icon: 'ri-calendar-line' },
    { id: 'equipos', label: 'Equipos', icon: 'ri-team-line' },
    { id: 'contacto', label: 'Contacto', icon: 'ri-phone-line' }
  ];

  return (
    <header className="fixed top-0 w-full bg-black/80 backdrop-blur-md border-b border-white/10 z-50">
      <div className="px-4 lg:px-8 py-3 lg:py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo y título */}
          <div className="flex items-center space-x-3 lg:space-x-4">
            <div className="flex items-center justify-center">
              <img
                src="./media/logos/logo_white.png"
                alt="Viu l'esport"
                className="h-[3rem] lg:h-[3.5rem] w-auto object-contain"
              />
            </div>
            <div>
              <h1 className="text-base lg:text-xl font-bold text-white">Viu l'esport</h1>
              <p className="text-xs lg:text-sm text-white/70">Club de Baloncesto</p>
            </div>
          </div>

          {/* Menú de navegación - Solo visible en desktop */}
          <nav className="hidden lg:flex items-center space-x-1">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveTab?.(item.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-300 ${
                  activeTab === item.id 
                    ? 'bg-pink-500 text-white' 
                    : 'text-white/70 hover:text-white hover:bg-white/10'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
                <span className="font-medium">{item.label}</span>
              </button>
            ))}
          </nav>

          {/* Botón de menú móvil - Solo visible en móvil */}
          <button className="hidden p-2 text-white/80 hover:text-white">
            <i className="ri-menu-line text-xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
